/**
 * Color palette definitions for light and dark themes.
 * All color values are defined as tokens here, replacing hard-coded hex values.
 */

/**
 * Brand tokens for ungloss.io.
 * Coral primary with a tinted text/ground pairing and a monochrome fallback.
 * These values mirror the brand spec and are consumed via `theme.palette.brand`.
 */
export const brand = {
    primary: '#D85A30', // coral
    tintedText: '#993C1D', // tinted text on tinted ground
    tintedGround: '#FAECE7', // soft coral-tinted background
    monochrome: '#1A1A1A', // fallback when coral cannot be used
} as const

export const lightPalette = {
    primary: {
        main: '#D85A30',
        light: '#E07C56',
        dark: '#A8431F',
    },
    secondary: {
        main: '#dc004e',
        light: '#ff5983',
        dark: '#9a0036',
    },
    brand,
    background: {
        default: '#f5f5f5',
        paper: '#ffffff',
    },
    text: {
        primary: 'rgba(0, 0, 0, 0.87)',
        secondary: 'rgba(0, 0, 0, 0.6)',
    },
    // Border colors for inputs
    border: {
        default: 'rgba(0, 0, 0, 0.23)',
        hover: 'rgba(0, 0, 0, 0.87)',
        focused: '#D85A30',
    },
    // Input label background (for shrink state)
    inputLabel: {
        background: '#ffffff',
    },
    // Shadow colors
    shadow: {
        card: '0 2px 8px rgba(0,0,0,0.1)',
    },
} as const

export const darkPalette = {
    primary: {
        main: '#E07C56',
        light: '#E89A7C',
        dark: '#D85A30',
    },
    secondary: {
        main: '#ff5983',
        light: '#ff80ab',
        dark: '#dc004e',
    },
    brand,
    background: {
        default: '#121212',
        paper: '#1e1e1e',
    },
    text: {
        primary: 'rgba(255, 255, 255, 0.87)',
        secondary: 'rgba(255, 255, 255, 0.6)',
    },
    // Border colors for inputs
    border: {
        default: 'rgba(255, 255, 255, 0.23)',
        hover: 'rgba(255, 255, 255, 0.87)',
        focused: '#E07C56',
    },
    // Input label background (for shrink state)
    inputLabel: {
        background: '#1e1e1e',
    },
    // Shadow colors
    shadow: {
        card: '0 2px 8px rgba(0,0,0,0.3)',
    },
} as const
